/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useContext, useEffect, useState, useRef } from 'react'
import { UltyModalWrapperContext } from '../Shared/UltyModalWrapper/UltyModalWrapperContext'
import ProviderChoice from '../Auth/ProviderChoice'
import { Segment, Form, Input, Button, Container, Grid, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { notify } from 'react-notify-toast'
import { login, loginToProvider } from '../../services/Auth/Auth.service'
import UserStore from '../Auth/store'
import { AUTH_TOKEN, MOBILE_THRESHOLD, RECAPTCHA_KEY } from '../../constants'
import ReCAPTCHA from 'react-google-recaptcha'
import useUser from '../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery'
import { useQueryClient } from '@tanstack/react-query'
import { UltyInputPassword } from '@ulty/ulty-ui'
import { useHelpToken } from './hooks/useHelpToken'
import useCanAccessHelp from './hooks/useCanAccessHelp'
import { useLocation, useNavigate } from 'react-router-dom-v5-compat'

const SSOZendesk = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const {isLoggedIn} = useUser()
    const { data } = useHelpToken();

    const canAccessHelp = useCanAccessHelp();

     const formRef = useRef(null);
     const inputRef = useRef(null);

   
    useEffect(() => {
        if(isLoggedIn && !canAccessHelp){
                navigate('/');
            }

        if(!isLoggedIn){
                const returnUrl = encodeURIComponent(location.pathname + location.search);
                navigate(`/auth/login?returnUrl=${returnUrl}`)
        }
    },[isLoggedIn,canAccessHelp,navigate,location])

    useEffect(() => {
        if(data){
            inputRef.current.value = data.userToken;
            formRef.current.submit();

            const autoRedirect = setTimeout(() => {
                const returnTo = new URLSearchParams(window.location.search).get('return_to');
                if(returnTo && returnTo.startsWith('https://help.ulty.fr')) {
                    navigate(returnTo)
                    return;
                }
            },2000);

            return autoRedirect;
        }
    },[data])


    return (
        <Segment textAlign='center'>
        <form ref={formRef} action={`https://ulty-help.zendesk.com/access/jwt`} method="post">
            <input ref={inputRef} type="hidden" name="jwt"></input>
        </form>
        {!data && <p>Connexion en cours..</p>}
        {data && <p>Connexion en cours...</p>}
      </Segment>
    )
}

export default SSOZendesk
